import ProductImage from "../../../../../../shared/ProductImage/ProductImage";

const CardProductPersonal = ({ data }) => {
    return (
        <div className="card-product-personal">
            <ProductImage className="product-img" src={data.imageUrl} alt="product" />
            <span className="product-server-profile">{data.name}</span>
        </div>
    );
};

export default CardProductPersonal;